import React from "react";
import "../../../styles/ViewModal.css";

const getNestedValue = (obj, path) => {
  if (!obj || typeof path !== "string") return "N/A";
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

const isImageUrl = (url) => {
  return /(jpeg|jpg|gif|png|svg)(\?.*)?$/.test(url);
};

const ContactUsViewModal = ({ show, onHide, data, fields }) => {
  if (!data) return null;

  const isObject = typeof data === "object" && !Array.isArray(data);

  if (!isObject) {
    const mappedData = Object.keys(fields).reduce((acc, key, index) => {
      acc[key] = data[index] || "N/A";
      return acc;
    }, {});
    data = mappedData;
  }

  return (
    <>
      {show && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full max-h-[calc(97vh_-_95px)] overflow-auto overflow-x-hidden mt-[73px]">
            <div className="flex justify-between items-center border-b p-4 fixed w-full max-w-lg py-2.5 rounded-[10px_10px_0_0] bg-[#fff]">
              <h2 className="text-lg font-semibold">Details</h2>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={onHide}
              >
                &times;
              </button>
            </div>
            <div className="px-4 pb-4 mt-[62px]">
              <div>
                {Object.entries(fields).map(([label, path]) => {
                  const value =
                    typeof path === "function"
                      ? path(data)
                      : getNestedValue(data, path) || "N/A";

                  return (
                    <div className="detail-item my-4" key={label}>
                      <span className="detail-label font-medium text-[#5d5d5d]">{label}:</span>
                      <span className="detail-value ml-2 font-normal">
                        {isImageUrl(value) ? (
                          <img
                            src={value}
                            alt={label}
                            className="max-h-32 rounded-md"
                          />
                        ) : React.isValidElement(value) ? (
                          <div className="font-semibold text-[13px]">{value}</div>
                        ) : (
                          <span className="font-semibold text-[13px]">{value}</span>
                        )}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="flex justify-end p-4 border-t">
              <button
                className="inline-flex items-center justify-center rounded-md border border-blue-500 py-2 px-6 text-center font-medium text-blue-500 hover:bg-opacity-90"
                onClick={onHide}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactUsViewModal;
